/**
 * The record slideout's attribution row: the creator · time line with the
 * privacy + owner cluster pinned at its end.
 *
 * One component so read mode (NoteCard) and inline-edit mode (MemoForm) can't
 * drift: both hand it the same attribution element and a `MemoFormControls`
 * cluster, so the row's geometry — and therefore the body's bottom edge — is
 * identical on both sides of the click-in. `mt-2` on the cluster matches
 * NoteAttribution's own top margin; the cluster's internal spacing belongs to
 * MemoFormControls.
 */

import type { ReactNode } from 'react';

export interface MemoAttributionRowProps {
  /** The creator · time line. Falsy renders a spacer so controls stay right. */
  attribution: ReactNode;
  /** The privacy + owner cluster — a `MemoFormControls` in both modes. */
  controls: ReactNode;
}

export function MemoAttributionRow({
  attribution,
  controls,
}: MemoAttributionRowProps) {
  return (
    <div className='flex items-center justify-between gap-3'>
      {attribution ?? <span />}
      <div className='mt-2 flex'>{controls}</div>
    </div>
  );
}
